function DockyardIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <path
        fill="#2d2d2d"
        d="M17.184,0H.82A.818.818,0,0,0,0,.818V17.182A.818.818,0,0,0,.82,18h9.273a.818.818,0,1,0,0-1.636H1.638V9.273H5.457v3a.818.818,0,1,0,1.636,0V4.636a.818.818,0,1,0-1.636,0v3H1.638v-6H9.82V5.727a.818.818,0,0,0,.818.818h3.818a.818.818,0,1,0,0-1.636h-3V1.636h4.909v9.818H10.638a.818.818,0,1,0,0,1.636h5.727v3.273H15A.818.818,0,1,0,15,18h2.182A.818.818,0,0,0,18,17.182V.818A.818.818,0,0,0,17.184,0Z"
        transform="translate(-0.002)"
      />
    </svg>
  );
}

export default DockyardIcon;
